import TaskTimer from './TaskTimer'
import enhance from './TaskTimer.enhancer'

export default enhance(TaskTimer)



// WEBPACK FOOTER //
// ./src/components/TaskTimer/index.js